import { gql } from '@src/lib/gql'

export const RESPOND_TO_BOARD_INVITE = gql`
  mutation RespondToBoardInvite($input: RespondToBoardInviteInput!) {
    respondToBoardInvite(input: $input) {
      advisorEngagement {
        id
        advisorEngagementId
        statusKey
        invitedAt
        activatedAt
        status {
          id
          key
          title
        }
      }
    }
  }
`
